
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/[question_slug]",
      function () {
        return require("private-next-pages/forum/[question_slug]/index.tsx");
      }
    ]);
  